var React = require('react');

function Section3MobileMiddleLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.4821 79.8121L18.8255 51.6828L35.3735 60.4815L14.4821 79.8121Z","fill":"#E9D8FD","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M27.4301 31.7217L35.4923 54.5374L12.3537 62.2985L4.29154 39.4828L27.4301 31.7217Z","fill":"#F58C8C","key":1}),React.createElement("rect",{"x":"25.1582","width":"19.0393","height":"19.0393","transform":"rotate(23 25.1582 0)","fill":"#FEFCBE","key":2})]);
}

Section3MobileMiddleLeftInline.defaultProps = {"width":"43","height":"80","viewBox":"0 0 43 80","fill":"none"};

module.exports = Section3MobileMiddleLeftInline;

Section3MobileMiddleLeftInline.default = Section3MobileMiddleLeftInline;
